import {FC, useState, useEffect, Fragment} from 'react'

import {Modal} from 'react-bootstrap'
import {useNavigate} from 'react-router-dom'
import Api from '../../../../../thesis-and-dissertations/helpers/api'
import handleApiError from 'thesis-and-dissertations/helpers/handleApiError'
import {toast} from 'react-toastify'
const api = new Api()

type Props = {
  showModal: boolean
  handleCloseModal: any
}

const LawModalContent: FC<Props> = ({showModal, handleCloseModal}) => {
  const navigate = useNavigate()
  const [show, setShow] = useState<any>(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setShow(showModal)
  }, [showModal])

  const handleClose = () => {
    setShow(false)
    handleCloseModal(false)
  }

  return (
    <Modal show={show} centered size='xl'>
      <div>
        <div className='modal-content overflow-hidden'>
          <div className='row g-0'>
            {/* <!-- Left Illustration Section --> */}
            <div
              className='col-md-6 d-flex justify-content-center align-items-center'
              style={{backgroundColor: '#F15A29'}}
            >
              <img
                src={require('../../../../../pana/assets/img/img-law.png')}
                alt='Ilustrasi'
                style={{maxHeight: '80%', maxWidth: '100%'}}
              />
            </div>

            {/* <!-- Right Text Section --> */}
            <div className='col-md-6 p-15 d-flex flex-column justify-content-center text-center'>
              <p className='display-6 fw-normal text-primary'>Pakta Integritas</p>
              <p className='mt-8' style={{fontWeight: '17px'}}>
                Sebelum melakukan penilaian, Verifikator wajib menandatangani pakta integritas.
              </p>

              <button
                className='btn btn-orange btn-lg fw-bold mt-8 text-white'
                style={{backgroundColor: '#F15A29'}}
                onClick={handleClose}
              >
                Tanda Tangan Sekarang!
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

const LawModal: FC<Props> = ({showModal, handleCloseModal}) => {
  return <LawModalContent showModal={showModal} handleCloseModal={handleCloseModal} />
}

export default LawModal
